import { useTranslation } from "react-i18next";

import { QuestionnaireImportance } from "@/pages/Public/pages/Questionnaire/enum/QuestionnaireImportance.enum";
import { ERROR_TYPE, translateError } from "@/utils";

interface ImportanceRadioGroupProps {
	options: QuestionnaireImportance[];
	value?: QuestionnaireImportance;
	name: string;
	onChange: (value: QuestionnaireImportance) => void;
	className?: string;
	errorMessage?: string;
}

export default function ImportanceRadioGroup({
	options,
	value,
	className,
	name,
	onChange,
	errorMessage,
}: ImportanceRadioGroupProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-questionnaire.${key}`);

	return (
		<div className={`flex relative gap-6 w-full ${className}`}>
			{options.map((option) => (
				<div
					key={option}
					className="rounded-lg p-0 w-fit flex items-center justify-center gap-2 cursor-pointer"
					onClick={() => onChange(option)}
				>
					<input
						checked={value === option}
						className="peer hidden"
						id={`${name}-${option}`}
						name={name}
						type="radio"
						value={option}
						onChange={() => onChange(option)}
					/>
					<label
						className="flex items-center gap-2 cursor-pointer relative before:w-5 before:h-5 before:rounded-full before:border before:border-gray-400 before:block before:content-[''] peer-checked:before:border-primary-blue peer-checked:before:bg-white peer-checked:before:ring-[1px] peer-checked:before:ring-primary-blue peer-checked:after:content-[''] peer-checked:after:w-3 peer-checked:after:h-3 peer-checked:after:rounded-full peer-checked:after:absolute peer-checked:after:left-[4px] peer-checked:after:top-[50%] peer-checked:after:-translate-y-1/2 peer-checked:after:block peer-checked:after:bg-primary-blue"
						htmlFor={`${name}-${option}`}
					>
						<p
							className="flex text-[14px] items-center font-medium leading-5"
							style={{ color: value === option ? "#B8431A" : "#686761" }}
						>
							{ts(option)}
						</p>
					</label>
				</div>
			))}
			{errorMessage && (
				<p className="absolute -bottom-5 text-[12px] text-danger">
					{translateError[errorMessage as unknown as ERROR_TYPE] ?? errorMessage}
				</p>
			)}
		</div>
	);
}
